import { useSearchPageFilters } from "@faire/retailer-visitor-shared/views/search-v2/SearchPageQueryParams/useSearchPageFilters";
import { useSearchPageIsFromDiscoverURL } from "@faire/retailer-visitor-shared/views/search-v2/SearchPageQueryParams/useSearchPageIsFromDiscoverURL";
import { useSearchPageProductSearchString } from "@faire/retailer-visitor-shared/views/search-v2/SearchPageQueryParams/useSearchPageProductSearchString";
import { useSearchPageQueryParams } from "@faire/retailer-visitor-shared/views/search-v2/SearchPageQueryParams/useSearchPageQueryParams";
import { useSearchPageZeroIndexedPageNumber } from "@faire/retailer-visitor-shared/views/search-v2/SearchPageQueryParams/useSearchPageZeroIndexedPageNumber";
import { route as filterRoute } from "@faire/web-api--source/api/v3/search/products/filters/post";
import { route as searchRoute } from "@faire/web-api--source/api/v3/search/products/post";
import { FilterSplitStrategy } from "@faire/web-api--source/indigofair/data/FilterSplitStrategy";
import { useMemo } from "react";
export var useSearchPageQueryQueryKey = function(pageNumParam) {
    var query = useSearchPageProductSearchString();
    var filters = useSearchPageFilters();
    var pageNumber = useSearchPageZeroIndexedPageNumber();
    var _useSearchPageQueryParams = useSearchPageQueryParams(), referrerType = _useSearchPageQueryParams.referrerType, refReqId = _useSearchPageQueryParams.refReqId, doQuerySpellCheck = _useSearchPageQueryParams.doQuerySpellCheck;
    var isFromDiscoverURL = useSearchPageIsFromDiscoverURL();
    return useMemo(function() {
        return [
            searchRoute,
            FilterSplitStrategy.PRODUCTS_ONLY,
            query,
            filters,
            pageNumParam !== null && pageNumParam !== void 0 ? pageNumParam : pageNumber,
            referrerType,
            refReqId,
            doQuerySpellCheck,
            isFromDiscoverURL
        ];
    }, [
        query,
        filters,
        pageNumParam,
        pageNumber,
        referrerType,
        refReqId,
        doQuerySpellCheck,
        isFromDiscoverURL
    ]);
};
export var useSearchPageFiltersQueryQueryKey = function() {
    var query = useSearchPageProductSearchString();
    var filters = useSearchPageFilters();
    var _useSearchPageQueryParams = useSearchPageQueryParams(), referrerType = _useSearchPageQueryParams.referrerType, refReqId = _useSearchPageQueryParams.refReqId, doQuerySpellCheck = _useSearchPageQueryParams.doQuerySpellCheck;
    var isFromDiscoverURL = useSearchPageIsFromDiscoverURL();
    return useMemo(function() {
        return [
            filterRoute,
            FilterSplitStrategy.AGGREGATIONS_ONLY,
            query,
            filters,
            referrerType,
            refReqId,
            doQuerySpellCheck,
            isFromDiscoverURL
        ];
    }, [
        doQuerySpellCheck,
        filters,
        query,
        refReqId,
        referrerType,
        isFromDiscoverURL
    ]);
};
